import request from "@/utils/request";
import { IRoleModel } from "./types";

export const defaultRoleData: IRoleModel = {
  id: null,
  name: null,
  menus: [],
  createdAt: null,
};

export const getRoles = () =>
  request({
    url: "/roles",
    method: "GET",
  });

export const getRoleDetail = (id: string) =>
  request({
    url: `/permissions/role/${id}`,
    method: "GET",
  });

export const getUserPermissionDetail = (id: string, account:string) =>
  request({
    url: `/permissions/user/${id}`,
    method: "GET",
    params:{ accountType: account }
  });

export const createRole = (name: string, menuIds: string[]) =>
  request({
    url: "/roles",
    method: "POST",
    data: { name, menuIds },
  });

export const createUserPermission = (userId: string, permissionIds: string[], accountType: string) =>
  request({
    url: "/role-permission/user",
    method: "POST",
    data: { userId, permissionIds, accountType },
  });

export const updateRole = (id: string, name: string, account: string, menuIds: string[]) =>
  request({
    url: `/roles/${id}`,
    method: "PUT",
    data: { name, accountType: account, menuIds },
  });

export const deleteRole = (id: string) =>
  request({
    url: `/roles/${id}`,
    method: "DELETE",
  });
 // /role-flow/{roleId}
 // 根据角色查询单据流权限
 export const getRoleFlow = (roleId: string, account: string) =>
  request({
    url: `/role-flow/${roleId}`,
    method: "GET",
    params:{ accountType: account }
  });
// 更改角色的单据流权限
export const postRoleFlow = (roleId: string,data) =>
  request({
    url: `/role-flow/${roleId}`,
    method: "POST",
    data
  });

// 获取带单据流类型
// /role-flow/enum
export const getRoleFlowEnum = (accountType: string) =>
  request({
    url: `/role-flow/enum`,
    method: "GET",
    params:{ accountType }
  });